import { useCallback } from "react"
import { batch } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"
import { useValidatorSeeker } from "@app"

import { useToast } from "@hooks"
import {
	acriss,
	acrissCategory,
	analyzerDate,
	categories,
	currency,
	fuelPolicy,
	includeProviders,
	insurance,
	inTerminal,
	mainProvider,
	mainSite,
	mileage,
	offices,
	prepaid,
	priceKpi,
	providers,
	reports,
	searchID,
	singleDate,
	sites,
	transmission
} from "@signals"
import { directSiteSchema } from "../schema"
import { analyzerFilters, isAnalyzerLoading, resetSignals, responseData, tableHasMainComparison, tableTabSelected } from "Pages/AnalyzersV2/@signals"
import { directSitesPayload } from "Pages/AnalyzersV2/DirectSites/@signals"
import { SECTIONS } from "Pages/AnalyzersV2/@constants"


export default function useAnalyzerDirectSiteFilters() {
	const { showToast } = useToast()

	const { isValid, errors } = useValidatorSeeker({
		singleDate: singleDate.value,
		currency: currency.value,
		officePickupID: offices.value,
		groupByAcriss: acrissCategory.value,
		dates: analyzerDate.value,
		providerID: providers.value,
		categoryID: categories.value,
		acriss: acriss.value,
	}, directSiteSchema(searchID.value))

	const onSubmit = useCallback((clearTab = false) => batch(() => {
		isAnalyzerLoading.value = true
		responseData.value = {}
		resetSignals(clearTab)
		tableHasMainComparison.value = !!mainSite.value || !!mainProvider.value
		return postSubmit("/api/dashboard/results", directSitesPayload.value).then(res => {
			batch(() => {
				responseData.value = { ...res, type: SECTIONS.DIRECT_SITE }
				analyzerFilters.value = res.filters
				isAnalyzerLoading.value = false
			})
		}).catch(() => {
			isAnalyzerLoading.value = false
			showToast.error()
		})
	}), [
		includeProviders.value, analyzerDate.value, providers.value,
		currency.value, offices.value, tableTabSelected.value, acriss.value,
		transmission.value, categories.value, fuelPolicy.value, providers.value,
		prepaid.value, mileage.value, priceKpi.value, inTerminal.value, insurance.value,
		includeProviders.value, sites.value, reports.value, isValid, singleDate.value
	])

	return {
		onSubmit: onSubmit,
		isValid: (isValid && !!reports.value) || !!searchID.value,
		errors: errors,
	}
}